import { IImageStyle, IImageStylePreset } from "shared/types";

export const getImageURLWithStyle = ({
  previewURL,
  imageStyles,
  style = IImageStylePreset.default,
}: {
  previewURL?: string;
  imageStyles?: IImageStyle[];
  style?: IImageStylePreset;
}): string => {
  if (previewURL) return previewURL;

  const selectedStyle = imageStyles?.find((imageStyle: IImageStyle) => imageStyle.style === style);

  if (selectedStyle) return selectedStyle.url;

  // if style not found, return first style
  return imageStyles?.[0].url || "";
};
